import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import HeroSection from './components/HeroSection';
import PlatformOverview from './components/PlatformOverview';
import WorkflowExamples from './components/WorkflowExamples';
import IntegrationShowcase from './components/IntegrationShowcase';
import CaseStudySection from './components/CaseStudySection';
import PricingSection from './components/PricingSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

const N8nMakeComWorkflows = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Structured Data for Google (Service Schema)
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "Workflow Automation",
    "provider": {
      "@type": "Organization",
      "name": "Make Mind Automations"
    },
    "areaServed": "Worldwide",
    "description": "Custom n8n and Make.com workflow development to automate business processes.",
    "offers": {
      "@type": "Offer",
      "priceCurrency": "USD",
      "price": "799",
      "priceSpecification": {
        "@type": "UnitPriceSpecification",
        "priceCurrency": "USD",
        "price": "799",
        "referenceQuantity": {
          "@type": "QuantitativeValue",
          "value": "1",
          "unitCode": "MON"
        }
      }
    }
  };

  return (
    <>
      <Helmet>
        <title>n8n & Make.com Automation Experts | Make Mind Automations</title>
        <meta 
          name="description" 
          content="Hire certified n8n and Make.com developers. We build complex, secure workflow automations to connect your apps and eliminate manual data entry." 
        />
        <meta 
          name="keywords" 
          content="n8n developers, Make.com agency, Integromat experts, Workflow Automation, Business Process Automation, Zapier Alternative" 
        />
        <meta property="og:title" content="n8n & Make.com Automation Services" />
        <meta property="og:description" content="Stop copying and pasting data. We build custom workflows that run your business on autopilot." />
        <script type="application/ld+json">
          {JSON.stringify(schemaData)}
        </script>
        <link
  rel="canonical"
  href="https://www.makemindautomations.tech/n8n-make-com-workflows"
/>
      </Helmet>

      <div className="min-h-screen bg-background text-foreground font-sans">
        <Header />
        
        <main>
          <HeroSection />
          <PlatformOverview />
          <WorkflowExamples />
          <IntegrationShowcase />
          <CaseStudySection />
          <PricingSection />
          <FAQSection />
          <CTASection />
        </main>

        <Footer />
      </div>
    </>
  );
};

export default N8nMakeComWorkflows;